import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { DatePickerHeader, DatePickerInput } from "./components";
import css from "./DatePicker.module.scss";

export interface DatePickerProps {
  startDate: string | null;
  endDate: string | null;
  onChange: (startDate: string | null, endDate: string | null) => void;
}

const DatePicker: React.FC<DatePickerProps> = ({ startDate, endDate, onChange }) => {
  const [isStartDateActive, setIsStartDateActive] = useState(true);
  const [isEndDateActive, setIsEndDateActive] = useState(false);

  const attrs = {
    container: {
      className: css.container,
    },
    fieldsWrapper: {
      className: css.fieldsWrapper,
    },
    datePickerWrapper: {
      className: css.datePickerWrapper,
    },
    startDateInput: {
      isActive: isStartDateActive,
      label: "Start date",
      value: startDate,
      onClick: () => {
        setIsEndDateActive(false);
        setIsStartDateActive(true);
      },
    },
    endDateInput: {
      isActive: isEndDateActive,
      label: "End date",
      value: endDate,
      onClick: () => {
        setIsStartDateActive(false);
        setIsEndDateActive(true);
      },
    },
    startDatePicker: {
      inline: true,
      selectsStart: true,
      selected: startDate ? new Date(startDate) : null,
      startDate: startDate ? new Date(startDate) : null,
      endDate: endDate ? new Date(endDate) : null,
      maxDate: endDate ? new Date(endDate) : null,
      renderCustomHeader: DatePickerHeader,
      onChange: (date: Date) => {
        onChange(date.toISOString(), endDate);
        setIsStartDateActive(false);
        setIsEndDateActive(true);
      },
    },
    endDatePicker: {
      inline: true,
      selectsEnd: true,
      selected: endDate ? new Date(endDate) : null,
      startDate: startDate ? new Date(startDate) : null,
      endDate: endDate ? new Date(endDate) : null,
      minDate: startDate ? new Date(startDate) : null,
      renderCustomHeader: DatePickerHeader,
      onChange: (date: Date) => {
        onChange(startDate, date.toISOString());
        setIsEndDateActive(false);
        setIsStartDateActive(true);
      },
    },
  };

  return (
    <div {...attrs.container}>
      <div {...attrs.fieldsWrapper}>
        <DatePickerInput {...attrs.startDateInput} />
        <DatePickerInput {...attrs.endDateInput} />
      </div>
      <div {...attrs.datePickerWrapper}>
        {isStartDateActive ? (
          // @ts-ignore
          <ReactDatePicker {...attrs.startDatePicker} />
        ) : null}
        {isEndDateActive ? (
          // @ts-ignore
          <ReactDatePicker {...attrs.endDatePicker} />
        ) : null}
      </div>
    </div>
  );
};

export default DatePicker;
